import React, { useState } from "react";
import LogoImg from "assets/images/logo.png";
import { useSelector } from 'react-redux';
import { NavLink } from "react-router-dom";
import Com from "components/styledComp/CommStyledComp";
import useMenuBtnDropDown from "hooks/useMenuBtnDropDown";

const Header = () => {
    
    const titleList = useSelector(state=>{
        return state.HeaderTitles.value;
    });

    const [isOpen, opnBtnref, clsBtnref, myPageHandler] = useMenuBtnDropDown(false);
    const [openMenuId, setOpenMenuId] = useState(null);
    const [hideSubmenu, setHideSubmenu] = useState(false);

    const toggleSubmenu = (id) => {
        // why: 모바일에서 전용 토글 아이콘으로만 아코디언 열고 닫기
        if (typeof window !== 'undefined' && window.innerWidth <= 1024) {
            setOpenMenuId(prev => prev === id ? null : id);
        }
    };

    const handleLinkClick = (e) => {
        // why: 링크 클릭 시 데스크톱에서도 서브메뉴를 즉시 숨겨 시야 방해 제거
        setHideSubmenu(true);
        if (e && e.currentTarget && typeof e.currentTarget.blur === 'function') {
            e.currentTarget.blur();
        } else if (typeof document !== 'undefined' && document.activeElement && typeof document.activeElement.blur === 'function') {
            document.activeElement.blur();
        }
        // why: 모바일에서 1뎁스/2뎁스 링크 클릭 시 이동 후 전체 메뉴 닫기
        if (typeof window !== 'undefined' && window.innerWidth <= 1024) {
            myPageHandler();
        }
    };

    return(
        <header className="header">
            {/* skip link for keyboard users */}
            <a href="#main" className="skip-link">본문 바로가기</a>
            <div className="header-inner">
                <h1>
                    <NavLink to="/">
                        {/* 로고이미지 */}
                        <img src={LogoImg} alt=""/>
                        <span hidden="hidden">한영디에스</span>
                    </NavLink>
                </h1>
                {/* 모바일일때 메뉴열기버튼 */}
                <button type="button" className="header-open" onClick={myPageHandler} ref={opnBtnref}>
                    <svg width="16" height="12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill="#232324" d="M0 0h16v2H0zM0 5h16v2H0zM0 10h16v2H0z"/>
                    </svg>
                </button>
                <div className={isOpen?"header-nav header-nav-open":"header-nav"}>
                    <div className="header-nav-top">
                        <NavLink className="header-nav-logo" to="/">
                            {/* 로고이미지 */}
                            <img src={LogoImg} alt=""/>
                        </NavLink>
                        {/* X버튼 */}
                        <Com.BtnNavBarClose type="button" onClick={myPageHandler} ref={clsBtnref}>
                            <svg viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M5.6 7L0 12.6l1.402 1.398L7 8.4l5.6 5.6 1.398-1.402L8.4 7 14 1.4 12.598.002 7 5.6 1.4 0 .002 1.402 5.6 7z" fill="#232324"/>
                            </svg>
                        </Com.BtnNavBarClose>
                    </div>
                    <nav className="header-global">
                        <ul className={hideSubmenu?"header-global-nav hide-submenu":"header-global-nav"} onMouseLeave={()=>setHideSubmenu(false)}>
                            {
                                titleList.map((id)=> {
                                    const supportClass = id.to === 'support' ? ' menu-support' : '';
                                    const openClass = openMenuId===id.id?" menu-open":"";
                                    return (
                                    <li key={id.id} className={`menu${supportClass}${openClass}`}>
                                        <strong>
                                            <NavLink to={`/${id.to}`} onClick={(e)=>handleLinkClick(e)}>{id.title}</NavLink>
                                            <button type="button" className="submenu-toggle" aria-expanded={openMenuId===id.id} aria-controls={`submenu-${id.id}`} aria-label="하위 메뉴 토글" onClick={()=>toggleSubmenu(id.id)}></button>
                                        </strong>
                                        {
                                            id.subTitles && (
                                                <ul id={`submenu-${id.id}`} role="group" className="submenu submenu-row">
                                                    {id.subTitles.map((sub) => {
                                                        const isDisabled = sub.subTo === 'support/news' || sub.subTo === 'support/questions';
                                                        return (
                                                            <li key={sub.subId}>
                                                                <NavLink to={`/${sub.subTo}`} onClick={(e)=>{
                                                                    if (isDisabled) { e.preventDefault(); alert('페이지 준비 중입니다.'); return; }
                                                                    handleLinkClick(e);
                                                                }}>{sub.subTitle}</NavLink>
                                                            </li>
                                                        );
                                                    })}
                                                </ul>
                                            )
                                        }
                                    </li>
                                    );
                                })
                            }
                        </ul>
                    </nav>
                    <div className="header-nav-foot">
                        <ul className="header-other">
                            <li>
                                <NavLink to="/support/notice">공지사항</NavLink>
                            </li>
                            <li>
                                <NavLink to="/support/location">오시는 길</NavLink>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </header>
    );
}

export default Header;